
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31042",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31042",
  "emoji-mart": "static-3.8",
  "feedback-schema": "static-1.55631",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8529",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11977",
  "I18n": "static-7.1711",
  "quartz": "static-1.7685",
  "quartz-config": "static-1.1463",
  "quartz-core": "static-1.6904",
  "react-dlb": "static-1.95",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.85",
  "reselect": "static-3.17",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1113",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55618",
  "feedback-utils": "static-1.55622",
  "forms-embed-utils-lib": "static-1.4951",
  "forms-utils-lib": "static-1.13360",
  "foundations-assets": "static-1.5378",
  "foundations-components": "static-1.8774",
  "foundations-theming": "static-1.4980",
  "hub-http": "static-1.6696",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12284",
  "icons": "static-2.706",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4239",
  "raven": "static-3.5925",
  "react": "static-7.203",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17229",
  "react-select-plus": "static-1.119",
  "react-utils": "static-2.5669",
  "react-virtualized": "static-2.113",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.519",
  "tinymce-plugins": "static-1.58535",
  "transmute": "static-2.97",
  "ui-images": "static-2.1280",
  "UIComponents": "static-3.8923",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3962",
  "quartz-webpack": "static-1.3909",
  "foundations-theming-specialty": "static-1.2696",
  "property-description-translator": "static-1.4310",
  "HeadJS": "static-2.825",
  "framer-motion": "static-1.85",
  "hs-test-utils-bend-plugin": "static-1.3640",
  "msw": "static-1.104",
  "msw-config": "static-1.31",
  "testing-library": "static-1.166",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.236",
  "moment-timezone": "static-5.97",
  "jasmine": "static-4.4796",
  "jasmine-runner": "static-1.6943",
  "opentelemetry-fe-types": "static-1.281",
  "dispatcher": "static-1.149",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.909",
  "hubspotter-http": "static-1.4983",
  "mobile-manifest-mixins": "static-1.608",
  "module-federation": "static-1.40",
  "opentelemetry-fe": "static-1.656",
  "quartz-auth": "static-1.1360",
  "quartz-head": "static-1.1350",
  "quartz-i18n": "static-1.1360",
  "quartz-routing": "static-1.1115",
  "quartz-test": "static-1.1360",
  "quartz-tracking": "static-1.1064",
  "trellis-components": "static-1.3146",
  "ui-fonts": "static-1.1239",
  "usage-tracker-container": "static-1.7803",
  "usage-tracker-core": "static-1.7663",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.378",
  "conversations-skeleton-state": "static-1.7610",
  "reference-resolvers": "static-1.8675",
  "sanitize-text": "static-1.8648",
  "PatternValidationJS": "static-1.3373",
  "ReduxMessenger": "static-2.10860",
  "outpost": "static-1.4619",
  "rpc-client-utils": "static-1.5159",
  "sanitize": "static-1.4965",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5043",
  "floating-ui": "static-1.69",
  "hs-story-utils": "static-1.9919",
  "react-aria": "static-1.78",
  "react-create-root-preference": "static-1.107",
  "tanstack-table": "static-1.67",
  "trellis-assets": "static-1.3127",
  "bend-plugin-foundations-theming": "static-1.3463",
  "foundations-theming-base": "static-1.3965",
  "stylex": "static-1.47",
  "hs-locale-management": "static-1.410",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.190",
  "web-vitals": "static-1.20",
  "ai-components-ui-library": "static-1.10051",
  "atom": "static-1.5562",
  "codemirror": "static-5.107",
  "content-assistance-lib": "static-1.8444",
  "ContentUtils": "static-1.69511",
  "data-token-picker": "static-1.17159",
  "file-manager-components": "static-1.24864",
  "FileManagerCore": "static-1.40363",
  "FileManagerLib": "static-1.40504",
  "frontend-preferences-client": "static-1.8412",
  "hub-http-contrib": "static-1.3523",
  "interframe": "static-3.5232",
  "layout-dnd-components": "static-1.13250",
  "layout-dnd-utils": "static-1.12225",
  "property-translator": "static-1.5870",
  "react-codemirror": "static-1.11132",
  "react-colorpicker": "static-2.10700",
  "reference-resolvers-lite": "static-1.8603",
  "rich-text-lib": "static-1.20579",
  "tinymce-data": "static-1.41506",
  "tinymce-themes": "static-1.57391",
  "ui-addon-emoji-picker": "static-1.10353",
  "ui-addon-sales-email": "static-1.5692",
  "ui-brand-identity-lib": "static-1.16989",
  "bender-build-tools": "static-1.3604",
  "opentelemetry-web": "static-1.24",
  "hub-http-shared-msw-handlers": "static-1.10929",
  "hubspotter-http-shared-msw-handlers": "static-1.10927",
  "usage-tracker-session-replay": "static-1.5499",
  "base-ui": "static-1.30",
  "react-day-picker": "static-1.16",
  "trellis-theming": "static-1.1504",
  "tanstack-virtual": "static-1.44",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.569",
  "chirp-fetch": "static-1.2395",
  "stylex-utils": "static-1.178",
  "chatspot-core": "static-1.23978",
  "copilot-toolkit": "static-1.12180",
  "customer-data-objects-ui-components": "static-1.13525",
  "data-fetching-client": "static-1.10129",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5248",
  "ui-addon-video-player": "static-1.9113",
  "ui-coaching-tips": "static-1.29599",
  "usage-tracker": "static-1.7813",
  "cms-field-types": "static-1.5300",
  "content-icons-ui": "static-1.2472",
  "integrations-lib": "static-1.17462",
  "customer-data-objects": "static-1.8197",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2238",
  "apollo-link-hub-http": "static-2.5079",
  "apollo-stack-hubspot": "static-3.100",
  "graphql": "static-1.94",
  "immer": "static-1.106",
  "immerable": "static-1.4632",
  "poll-commands": "static-1.3968",
  "ui-addon-iframeable": "static-1.9568",
  "video-components-external": "static-1.12471",
  "video-data-lib": "static-1.36129",
  "audio-components": "static-1.6594",
  "breeze-artifacts-sdk": "static-1.1039",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30084",
  "FileManagerImages": "static-1.38015",
  "foundations-components-legacy": "static-1.1799",
  "html-to-image": "static-1.66",
  "redux-toolkit": "static-1.83",
  "salesImages": "static-1.748",
  "ui-universal-auth": "static-1.9770",
  "urlinator": "static-1.5004",
  "video-components": "static-1.14473",
  "video-embed": "static-1.36963",
  "ts-schema": "static-1.4403",
  "ContentData": "static-1.69586",
  "layout-data-lib": "static-1.10550",
  "react-dnd-compat": "static-1.5100",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2039",
  "external-options-client-types": "static-1.4447",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6082",
  "hs-resources": "static-1.673",
  "inbound-db-properties-service-client": "static-1.4159",
  "NamespacedHubStyle": "static-2.9376",
  "growth-onboarding-confetti": "static-1.3548",
  "SharedI18nStrings": "static-1.189",
  "ui-addon-i18n": "static-1.11635",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5920",
  "magpie-types": "static-1.5380",
  "simple-logging-lib": "static-1.3541",
  "avatar-components": "static-1.2977",
  "customer-data-ui-utilities": "static-1.10322",
  "growth-onboarding-feedback-components": "static-1.7071",
  "flux-actions": "static-1.382",
  "hubspot-apollo-client": "static-1.5373",
  "integrations-error-boundary-lib": "static-1.14877",
  "integrations-tracking-lib": "static-1.6113",
  "laboratory-lib": "static-3.7637",
  "native-integrations-shared-strings": "static-1.8253",
  "redux-observable": "static-1.80",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10770",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1216",
  "breeze-engine-core": "static-1.1516",
  "highlight.js": "static-1.91",
  "pulse": "static-1.1139",
  "navigation-messaging": "static-1.8526",
  "content-media-composition-data-lib": "static-1.13625",
  "content-media-compositions": "static-2.17632",
  "idb-keyval": "static-1.56",
  "media-bridge-lib": "static-1.19665",
  "nudge-client-utils": "static-1.3446",
  "custom-vendor-connection-lib": "static-1.334",
  "unified-auth-core-lib": "static-1.1566",
  "social-insights-client-types": "static-1.22957",
  "advanced-menus-core": "static-1.15841",
  "advanced-menus-lib": "static-1.12587",
  "ExportDialog": "static-6.10863",
  "ui-memberships-settings-lib": "static-1.35230",
  "conditional-properties-service-client": "static-1.4121",
  "crm-pipelines-api-client-types": "static-1.4452",
  "event-emitter": "static-1.1452",
  "fdsr-migration-layer": "static-1.502",
  "framework-builder-read-service-client": "static-1.4344",
  "inbound-db-meta-service-client": "static-1.3783",
  "multi-currency-client-types": "static-1.4017",
  "foundations-components-test-utils": "static-1.6257",
  "reactive-lib": "static-1.1211",
  "trellis-migration-context": "static-1.71",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.832",
  "universal-page-editor-lib": "static-1.3503",
  "bend-plugin-pulse": "static-1.642",
  "fast-json-patch": "static-1.75",
  "nav-meta": "static-1.30836",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3203",
  "nudge-renderer-utils": "static-1.3522",
  "onboarding-tours": "static-1.17411",
  "whisper-core-api": "static-1.7666",
  "fsm": "static-1.4247",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15840",
  "simple-menus-lib": "static-1.17357",
  "settings-ui-lib": "static-1.13018",
  "persist-promise": "static-1.4196",
  "crm-record-cards-client": "static-1.90",
  "crm-record-cards-service-types": "static-1.3871",
  "framework-data-schema-resolvers": "static-1.7383",
  "location-customization-utils-lib": "static-1.10451",
  "getting-started-shared-tasks": "static-1.19592",
  "growth-data-modal": "static-1.6158",
  "growth-onboarding-next-action-utils": "static-1.3013",
  "navigation-components": "static-1.19199",
  "nest": "static-1.725",
  "onboarding-tours-client": "static-1.5626",
  "onboarding-tours-utils": "static-1.1478",
  "ui-shepherd-tracker": "static-1.8151",
  "user-context": "static-1.5544",
  "react-flip-move": "static-1.84",
  "framework-data-schema-quick-fetch": "static-1.7288",
  "onboarding-data-sync-lib": "static-1.2861",
  "growth-onboarding-next-action-components": "static-1.3041",
  "user-context-client": "static-1.5000",
  "getting-started-shared-tasks-store": "static-1.18710",
  "InboxConnectUtils": "static-4.15869",
  "meetings-connect-utils-lib": "static-1.8110",
  "onboarding-scopes": "static-1.6944"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31042",
  "emoji-mart": "/emoji-mart/static-3.8",
  "feedback-schema": "/feedback-schema/static-1.55631",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8529",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11977",
  "I18n": "/I18n/static-7.1711",
  "quartz": "/quartz/static-1.7685",
  "quartz-config": "/quartz-config/static-1.1463",
  "quartz-core": "/quartz-core/static-1.6904",
  "react-dlb": "/react-dlb/static-1.95",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.85",
  "reselect": "/reselect/static-3.17",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1113",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55618",
  "feedback-utils": "/feedback-utils/static-1.55622",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4951",
  "forms-utils-lib": "/forms-utils-lib/static-1.13360",
  "foundations-assets": "/foundations-assets/static-1.5378",
  "foundations-components": "/foundations-components/static-1.8774",
  "foundations-theming": "/foundations-theming/static-1.4980",
  "hub-http": "/hub-http/static-1.6696",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12284",
  "icons": "/icons/static-2.706",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4239",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.203",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17229",
  "react-select-plus": "/react-select-plus/static-1.119",
  "react-utils": "/react-utils/static-2.5669",
  "react-virtualized": "/react-virtualized/static-2.113",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.519",
  "tinymce-plugins": "/tinymce-plugins/static-1.58535",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1280",
  "UIComponents": "/UIComponents/static-3.8923",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3962",
  "quartz-webpack": "/quartz-webpack/static-1.3909",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2696",
  "property-description-translator": "/property-description-translator/static-1.4310",
  "HeadJS": "/HeadJS/static-2.825",
  "framer-motion": "/framer-motion/static-1.85",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3640",
  "msw": "/msw/static-1.104",
  "msw-config": "/msw-config/static-1.31",
  "testing-library": "/testing-library/static-1.166",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.236",
  "moment-timezone": "/moment-timezone/static-5.97",
  "jasmine": "/jasmine/static-4.4796",
  "jasmine-runner": "/jasmine-runner/static-1.6943",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.281",
  "dispatcher": "/dispatcher/static-1.149",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.909",
  "hubspotter-http": "/hubspotter-http/static-1.4983",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.608",
  "module-federation": "/module-federation/static-1.40",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.656",
  "quartz-auth": "/quartz-auth/static-1.1360",
  "quartz-head": "/quartz-head/static-1.1350",
  "quartz-i18n": "/quartz-i18n/static-1.1360",
  "quartz-routing": "/quartz-routing/static-1.1115",
  "quartz-test": "/quartz-test/static-1.1360",
  "quartz-tracking": "/quartz-tracking/static-1.1064",
  "trellis-components": "/trellis-components/static-1.3146",
  "ui-fonts": "/ui-fonts/static-1.1239",
  "usage-tracker-container": "/usage-tracker-container/static-1.7803",
  "usage-tracker-core": "/usage-tracker-core/static-1.7663",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.378",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7610",
  "reference-resolvers": "/reference-resolvers/static-1.8675",
  "sanitize-text": "/sanitize-text/static-1.8648",
  "PatternValidationJS": "/PatternValidationJS/static-1.3373",
  "ReduxMessenger": "/ReduxMessenger/static-2.10860",
  "outpost": "/outpost/static-1.4619",
  "rpc-client-utils": "/rpc-client-utils/static-1.5159",
  "sanitize": "/sanitize/static-1.4965",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5043",
  "floating-ui": "/floating-ui/static-1.69",
  "hs-story-utils": "/hs-story-utils/static-1.9919",
  "react-aria": "/react-aria/static-1.78",
  "react-create-root-preference": "/react-create-root-preference/static-1.107",
  "tanstack-table": "/tanstack-table/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.3127",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3463",
  "foundations-theming-base": "/foundations-theming-base/static-1.3965",
  "stylex": "/stylex/static-1.47",
  "hs-locale-management": "/hs-locale-management/static-1.410",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.190",
  "web-vitals": "/web-vitals/static-1.20",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10051",
  "atom": "/atom/static-1.5562",
  "codemirror": "/codemirror/static-5.107",
  "content-assistance-lib": "/content-assistance-lib/static-1.8444",
  "ContentUtils": "/ContentUtils/static-1.69511",
  "data-token-picker": "/data-token-picker/static-1.17159",
  "file-manager-components": "/file-manager-components/static-1.24864",
  "FileManagerCore": "/FileManagerCore/static-1.40363",
  "FileManagerLib": "/FileManagerLib/static-1.40504",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8412",
  "hub-http-contrib": "/hub-http-contrib/static-1.3523",
  "interframe": "/interframe/static-3.5232",
  "layout-dnd-components": "/layout-dnd-components/static-1.13250",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12225",
  "property-translator": "/property-translator/static-1.5870",
  "react-codemirror": "/react-codemirror/static-1.11132",
  "react-colorpicker": "/react-colorpicker/static-2.10700",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8603",
  "rich-text-lib": "/rich-text-lib/static-1.20579",
  "tinymce-data": "/tinymce-data/static-1.41506",
  "tinymce-themes": "/tinymce-themes/static-1.57391",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10353",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5692",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16989",
  "bender-build-tools": "/bender-build-tools/static-1.3604",
  "opentelemetry-web": "/opentelemetry-web/static-1.24",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10929",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10927",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5499",
  "base-ui": "/base-ui/static-1.30",
  "react-day-picker": "/react-day-picker/static-1.16",
  "trellis-theming": "/trellis-theming/static-1.1504",
  "tanstack-virtual": "/tanstack-virtual/static-1.44",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.569",
  "chirp-fetch": "/chirp-fetch/static-1.2395",
  "stylex-utils": "/stylex-utils/static-1.178",
  "chatspot-core": "/chatspot-core/static-1.23978",
  "copilot-toolkit": "/copilot-toolkit/static-1.12180",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13525",
  "data-fetching-client": "/data-fetching-client/static-1.10129",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5248",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9113",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29599",
  "usage-tracker": "/usage-tracker/static-1.7813",
  "cms-field-types": "/cms-field-types/static-1.5300",
  "content-icons-ui": "/content-icons-ui/static-1.2472",
  "integrations-lib": "/integrations-lib/static-1.17462",
  "customer-data-objects": "/customer-data-objects/static-1.8197",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2238",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5079",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.100",
  "graphql": "/graphql/static-1.94",
  "immer": "/immer/static-1.106",
  "immerable": "/immerable/static-1.4632",
  "poll-commands": "/poll-commands/static-1.3968",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9568",
  "video-components-external": "/video-components-external/static-1.12471",
  "video-data-lib": "/video-data-lib/static-1.36129",
  "audio-components": "/audio-components/static-1.6594",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1039",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30084",
  "FileManagerImages": "/FileManagerImages/static-1.38015",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1799",
  "html-to-image": "/html-to-image/static-1.66",
  "redux-toolkit": "/redux-toolkit/static-1.83",
  "salesImages": "/salesImages/static-1.748",
  "ui-universal-auth": "/ui-universal-auth/static-1.9770",
  "urlinator": "/urlinator/static-1.5004",
  "video-components": "/video-components/static-1.14473",
  "video-embed": "/video-embed/static-1.36963",
  "ts-schema": "/ts-schema/static-1.4403",
  "ContentData": "/ContentData/static-1.69586",
  "layout-data-lib": "/layout-data-lib/static-1.10550",
  "react-dnd-compat": "/react-dnd-compat/static-1.5100",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2039",
  "external-options-client-types": "/external-options-client-types/static-1.4447",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6082",
  "hs-resources": "/hs-resources/static-1.673",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4159",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9376",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3548",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.189",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11635",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5920",
  "magpie-types": "/magpie-types/static-1.5380",
  "simple-logging-lib": "/simple-logging-lib/static-1.3541",
  "avatar-components": "/avatar-components/static-1.2977",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10322",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7071",
  "flux-actions": "/flux-actions/static-1.382",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5373",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14877",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6113",
  "laboratory-lib": "/laboratory-lib/static-3.7637",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8253",
  "redux-observable": "/redux-observable/static-1.80",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10770",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1216",
  "breeze-engine-core": "/breeze-engine-core/static-1.1516",
  "highlight.js": "/highlight.js/static-1.91",
  "pulse": "/pulse/static-1.1139",
  "navigation-messaging": "/navigation-messaging/static-1.8526",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13625",
  "content-media-compositions": "/content-media-compositions/static-2.17632",
  "idb-keyval": "/idb-keyval/static-1.56",
  "media-bridge-lib": "/media-bridge-lib/static-1.19665",
  "nudge-client-utils": "/nudge-client-utils/static-1.3446",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.334",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1566",
  "social-insights-client-types": "/social-insights-client-types/static-1.22957",
  "advanced-menus-core": "/advanced-menus-core/static-1.15841",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12587",
  "ExportDialog": "/ExportDialog/static-6.10863",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35230",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4121",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4452",
  "event-emitter": "/event-emitter/static-1.1452",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.502",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4344",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3783",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4017",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6257",
  "reactive-lib": "/reactive-lib/static-1.1211",
  "trellis-migration-context": "/trellis-migration-context/static-1.71",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.832",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3503",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.642",
  "fast-json-patch": "/fast-json-patch/static-1.75",
  "nav-meta": "/nav-meta/static-1.30836",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3203",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3522",
  "onboarding-tours": "/onboarding-tours/static-1.17411",
  "whisper-core-api": "/whisper-core-api/static-1.7666",
  "fsm": "/fsm/static-1.4247",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15840",
  "simple-menus-lib": "/simple-menus-lib/static-1.17357",
  "settings-ui-lib": "/settings-ui-lib/static-1.13018",
  "persist-promise": "/persist-promise/static-1.4196",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.90",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7383",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10451",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19592",
  "growth-data-modal": "/growth-data-modal/static-1.6158",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3013",
  "navigation-components": "/navigation-components/static-1.19199",
  "nest": "/nest/static-1.725",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5626",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1478",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8151",
  "user-context": "/user-context/static-1.5544",
  "react-flip-move": "/react-flip-move/static-1.84",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7288",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2861",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3041",
  "user-context-client": "/user-context-client/static-1.5000",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18710",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15869",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8110",
  "onboarding-scopes": "/onboarding-scopes/static-1.6944"
}
};
